import { SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS } from "store/hazardReport/actionTypes";
import {
  STAFF_GET_EVENTS_SUCCESS,
  STAFF_GET_EVENTS_FAIL,
  STAFF_PART_DETAILS_SUCCESS,
  STAFF_PART_DETAILS_FAIL,
  SERVICE_PROGRESS_NOTE,
  SERVICE_PROGRESS_NOTE_SUCCESS,
  SERVICE_PROGRESS_NOTE_FAIL,
  SERVICE_ITEM_DETAILS_SUCCESS,
  SERVICE_ITEM_DETAILS_FAIL,
  POST_CLOCK_IN_TIME_SUCCESS,
  POST_CLOCK_IN_TIME_FAIL,
  STAFF_TASK_ID,
  STAFF_TASK_ID_SUCCESS,
  STAFF_TASK_ID_FAIL,
  GET_NOTE_BY_ID_SUCCESS,
  GET_NOTE_BY_ID_FAIL,
  UPDATE_STAFF_PRO_NOTE_FAIL,
  UPDATE_STAFF_PRO_NOTE_SUCCESS,
  LOGOUT_STAFF_FAIL,
  LOGOUT_STAFF_SUCCESS,
  POST_TIMMINGS_SUCCESS,
  POST_TIMMINGS_FAIL,
  STAFF_ACTION_SUCCESS,
  STAFF_ACTION_FAIL,
  SUBMIT_INICIDENT_REPORT_SUCCESS,
  SUBMIT_INICIDENT_REPORT_FAIL,
  SET_TASK_TIMEOUT_SUCCESS,
  SET_TASK_TIMEOUT_FAIL,
  SHOW_MODAL,
  HIDE_MODAL,
  SUBMITION_APPROVAL_FAIL,
  SUBMITION_APPROVAL_SUCCESS,
  NOTES_BY_ADMIN_FAIL,
  NOTES_BY_ADMIN_SUCCESS,
  GET_EMPLOYEE_PROFILE_DETAILS_FAIL,
  GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS,
  SEND_ATTACHMENTS_BY_EMPLOYEE_FAIL,
  SEND_ATTACHMENTS_BY_EMPLOYEE_SUCCESS,
  UPLOAD_REQ_DOCS_FAIL,
  UPLOAD_REQ_DOCS_SUCCESS,
  UPLOAD_STAFF_CERTIFICATE_DOCS_FAIL,
  UPLOAD_STAFF_CERTIFICATE_DOCS_SUCCESS,
  GET_DOCUMENTS_STATUS_LIST_FAIL,
  GET_DOCUMENTS_STATUS_LIST_SUCCESS,
  GET_TRAININGS_STAFF_FAIL,
  GET_TRAININGS_STAFF_SUCCESS,
  GET_INICIDENT_FORM_QUESTIONS_FAIL,
  GET_INICIDENT_FORM_QUESTIONS_SUCCESS,
  SUBMIT_INCIDENT_FORM_EMPLOYEE_FAIL,
  SUBMIT_INCIDENT_FORM_EMPLOYEE_SUCCESS,
  GET_POLICY_FOR_EMPLOYEE_FAIL,
  GET_POLICY_FOR_EMPLOYEE_SUCCESS,
  CONFIRM_TRAINING_TERMS_FAIL,
  CONFIRM_TRAINING_TERMS_SUCCESS,
  HIT_DOWNLOAD_FAIL,
  HIT_DOWNLOAD_SUCCESS,
  GET_MY_SHIFTS_SUCCESS,
  GET_MY_SHIFTS_FAIL,
  EMP_GET_FOLDERS_SUCCESS,
  EMP_GET_FOLDERS_FAIL,
  EMP_GET_FOLDER_FILES_SUCCESS,
  EMP_GET_FOLDER_FILES_FAIL,
  EMP_ADD_FILE_TO_FOLDER_SUCCESS,
  EMP_ADD_FILE_TO_FOLDER_FAIL,
  EMP_GET_FOLDER_FILES,
  SEND_ATTACHMENTS_BY_EMPLOYEE,
  START_EMP_SHIFT_SUCCESS,
  START_EMP_SHIFT_FAIL,
  END_EMP_SHIFT_SUCCESS,
  END_EMP_SHIFT_FAIL,
  EMP_ADD_AVAILABILITY_SUCCESS,
  EMP_ADD_AVAILABILITY_FAIL,
  EMP_AVAILABILITY_SUCCESS,
  EMP_AVAILABILITY_FAIL,
  EMP_GET_OPEN_SHIFTS_SUCCESS,
  EMP_GET_OPEN_SHIFTS_FAIL,
  REQUEST_OPEN_SHIFT_SUCCESS,
  REQUEST_OPEN_SHIFT_FAIL,
  CANCEL_OPEN_SHIFT_SUCCESS,
  CANCEL_OPEN_SHIFT_FAIL,
  GET_REQUESTED_OPEN_SHIFTS_SUCCESS,
  GET_REQUESTED_OPEN_SHIFTS_FAIL,
  USER_ACCOUNTS_LIST_SUCCESS,
  USER_ACCOUNTS_LIST_FAIL,
  SWITCH_ACCOUNT_SUCCESS,
  SWITCH_ACCOUNT_FAIL,
  REMOVE_EMP_SWITCH_ACCOUNT_SUCCESS,
  REMOVE_EMP_SWITCH_ACCOUNT_FAIL,
  GET_EMP_PROFILE_DATA_SUCCESS,
  GET_MEDICATION_DETAILS_SUCCESS,
  GET_MEDICATION_DETAILS_FAIL,
  SUBMIT_MED_REPORT_SUCCESS,
  SUBMIT_MED_REPORT_FAIL,
  GET_EMP_MEDICINE_LIST_SUCCESS,
  GET_EMP_MEDICINE_LIST_FAIL,
  GET_TODAYS_MEDICATION,
  GET_TODAYS_MEDICATION_SUCCESS,
  GET_TODAYS_MEDICATION_FAIL,
  EMP_SUBMIT_MEDICATION_SUCCESS,
  EMP_SUBMIT_MEDICATION_FAIL,
  EMP_MEDICATION_PRN,
  EMP_MEDICATION_PRN_SUCCESS,
  EMP_MEDICATION_PRN_FAIL,
  SUBMIT_HAZARD_REPORT_SUCCESS,
  SUBMIT_HAZARD_REPORT_FAIL,
  SAVE_PROGRESS_NOTE_FAIL,
  SAVE_PROGRESS_NOTE_SUCCESS,
  REFINE_TEXT_FAIL,
  REFINE_TEXT_SUCCESS,
  GET_SUPPORT_WORKER_TIME_SHEETS_FAIL,
  GET_SUPPORT_WORKER_TIME_SHEETS_SUCCESS,
  SUBMIT_TIMESHEET_COMMENT_FAIL,
  SUBMIT_TIMESHEET_COMMENT_SUCCESS,
  UPDATE_VEHICLE_DETAILS_EMPLOYEE_SUCCESS,
  UPDATE_VEHICLE_DETAILS_EMPLOYEE_FAIL,
  SUBMIT_EMPLOYEE_COMPLAINT_FORM_SUCCESS,
  SUBMIT_EMPLOYEE_COMPLAINT_FORM_FAIL,
  EMP_UPDATE_AVAILABILITY_SUCCESS,
  EMP_UPDATE_AVAILABILITY_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  me: [],
  tasks: [],
  partDetails: [],
  progNotes: [],
  progNotes_err: false,
  error: {},
  succRes: [],
  serItemDetail: [],
  taskDetails: [],
  docs: [],
  res: [],
  noteById: [],
  updateNote: [],
  clockInres: [],
  openModal: false,
  profile: [],
  attachRes: [],
  reqDocRes: [],
  docStatusList: [],
  trainingList: [],
  certUploadRes: [],
  incidentQues: [],
  incidentSubmitRes: [],
  policyList: [],
  confirmRes: [],
  hitRes: [],
  myShifts: [],

  folders: [],
  loading: false,
  files: [],
  fileRes: [],

  taskUploadRes: [],
  shiftAction: [],
  availabilityList: [],
  availabilityRes: [],
  openShift: [],
  requestedShiftList: [],
  accounts: [],
  updateavailabilityRes: [],

  medication: [],
  medList: [],
  todaysMed: [],
  medicationPRN: [],

  list: [],
};

const StaffView = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_VEHICLE_DETAILS_EMPLOYEE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case UPDATE_VEHICLE_DETAILS_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_TIMESHEET_COMMENT_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case GET_SUPPORT_WORKER_TIME_SHEETS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SUPPORT_WORKER_TIME_SHEETS_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case REFINE_TEXT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REFINE_TEXT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SAVE_PROGRESS_NOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SAVE_PROGRESS_NOTE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SUBMIT_HAZARD_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_HAZARD_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case EMP_MEDICATION_PRN:
      return {
        ...state,
        medicationPRN: [],
      };
    case EMP_MEDICATION_PRN_SUCCESS:
      return {
        ...state,
        medicationPRN: action.payload,
      };
    case EMP_MEDICATION_PRN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TODAYS_MEDICATION:
      return {
        ...state,
        todaysMed: [],
      };
    case GET_TODAYS_MEDICATION_SUCCESS:
      return {
        ...state,
        todaysMed: action.payload,
      };
    case GET_TODAYS_MEDICATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_EMP_MEDICINE_LIST_SUCCESS:
      return {
        ...state,
        medList: action.payload,
      };

    case GET_EMP_MEDICINE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EMP_SUBMIT_MEDICATION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case EMP_SUBMIT_MEDICATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_MED_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case SUBMIT_MED_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MEDICATION_DETAILS_SUCCESS:
      return {
        ...state,
        medication: action.payload,
      };

    case GET_MEDICATION_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REMOVE_EMP_SWITCH_ACCOUNT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case REMOVE_EMP_SWITCH_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SWITCH_ACCOUNT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case SWITCH_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CANCEL_OPEN_SHIFT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case CANCEL_OPEN_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case USER_ACCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        accounts: action.payload,
      };

    case USER_ACCOUNTS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_REQUESTED_OPEN_SHIFTS_SUCCESS:
      return {
        ...state,
        requestedShiftList: action.payload,
      };

    case GET_REQUESTED_OPEN_SHIFTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REQUEST_OPEN_SHIFT_SUCCESS:
      return {
        ...state,
        loading: true,
        res: action.payload,
      };

    case REQUEST_OPEN_SHIFT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case EMP_GET_OPEN_SHIFTS_SUCCESS:
      return {
        ...state,
        openShift: action.payload,
      };

    case EMP_GET_OPEN_SHIFTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EMP_ADD_AVAILABILITY_SUCCESS:
      return {
        ...state,
        availabilityRes: action.payload,
      };

    case EMP_ADD_AVAILABILITY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case EMP_UPDATE_AVAILABILITY_SUCCESS:
      return {
        ...state,
        updateavailabilityRes: action.payload,
      };

    case EMP_UPDATE_AVAILABILITY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case EMP_AVAILABILITY_SUCCESS:
      return {
        ...state,
        availabilityList: action.payload,
      };

    case EMP_AVAILABILITY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case END_EMP_SHIFT_SUCCESS:
      return {
        ...state,
        shiftAction: action.payload,
      };

    case END_EMP_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case START_EMP_SHIFT_SUCCESS:
      return {
        ...state,
        shiftAction: action.payload,
      };

    case START_EMP_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EMP_GET_FOLDERS_SUCCESS:
      return {
        ...state,
        folders: action.payload,
      };

    case EMP_GET_FOLDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EMP_GET_FOLDER_FILES:
      return {
        ...state,
        loading: true,
        files: [],
      };
    case EMP_GET_FOLDER_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        files: action.payload,
      };

    case EMP_GET_FOLDER_FILES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case EMP_ADD_FILE_TO_FOLDER_SUCCESS:
      return {
        ...state,
        fileRes: action.payload,
      };

    case EMP_ADD_FILE_TO_FOLDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case HIT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        hitRes: action.payload,
      };
    case HIT_DOWNLOAD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MY_SHIFTS_SUCCESS:
      return {
        ...state,
        myShifts: action.payload,
      };
    case GET_MY_SHIFTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CONFIRM_TRAINING_TERMS_SUCCESS:
      return {
        ...state,
        confirmRes: action.payload,
      };
    case CONFIRM_TRAINING_TERMS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_POLICY_FOR_EMPLOYEE_SUCCESS:
      return {
        ...state,
        policyList: action.payload,
      };
    case GET_POLICY_FOR_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_INCIDENT_FORM_EMPLOYEE_SUCCESS:
      return {
        ...state,
        incidentSubmitRes: action.payload,
      };
    case SUBMIT_INCIDENT_FORM_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_INICIDENT_FORM_QUESTIONS_SUCCESS:
      return {
        ...state,
        incidentQues: action.payload,
      };
    case GET_INICIDENT_FORM_QUESTIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TRAININGS_STAFF_SUCCESS:
      return {
        ...state,
        trainingList: action.payload,
      };
    case GET_TRAININGS_STAFF_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_DOCUMENTS_STATUS_LIST_SUCCESS:
      return {
        ...state,
        docStatusList: action.payload,
      };
    case GET_DOCUMENTS_STATUS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPLOAD_STAFF_CERTIFICATE_DOCS_SUCCESS:
      return {
        ...state,
        certUploadRes: action.payload,
      };
    case UPLOAD_STAFF_CERTIFICATE_DOCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPLOAD_REQ_DOCS_SUCCESS:
      return {
        ...state,
        reqDocRes: action.payload,
      };
    case UPLOAD_REQ_DOCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SEND_ATTACHMENTS_BY_EMPLOYEE:
      return {
        ...state,
        taskUploadRes: [],
      };
    case SEND_ATTACHMENTS_BY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        taskUploadRes: action.payload,
      };
    case SEND_ATTACHMENTS_BY_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };
    case GET_EMPLOYEE_PROFILE_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case NOTES_BY_ADMIN_SUCCESS:
      return {
        ...state,
        taskDetails: action.payload,
      };
    case NOTES_BY_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMITION_APPROVAL_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SUBMITION_APPROVAL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case HIDE_MODAL:
      return {
        ...state,
        openModal: false,
      };
    case SHOW_MODAL:
      return {
        ...state,
        openModal: true,
      };
    case SET_TASK_TIMEOUT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case SET_TASK_TIMEOUT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_INICIDENT_REPORT_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case SUBMIT_INICIDENT_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case STAFF_ACTION_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case STAFF_ACTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_TIMMINGS_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case POST_TIMMINGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case LOGOUT_STAFF_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case LOGOUT_STAFF_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_STAFF_PRO_NOTE_SUCCESS:
      return {
        ...state,
        openModal: false,
        updateNote: action.payload,
      };

    case UPDATE_STAFF_PRO_NOTE_FAIL:
      return {
        ...state,
        openModal: false,
        error: action.payload,
      };

    case GET_NOTE_BY_ID_SUCCESS:
      return {
        ...state,
        noteById: action.payload,
      };

    case GET_NOTE_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    // case STAFF_TASK_ID:
    //   return {
    //     ...state,
    //     taskDetails: [],
    //   };
    case STAFF_TASK_ID_SUCCESS:
      return {
        ...state,
        taskDetails: action.payload,
      };

    case STAFF_TASK_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case STAFF_GET_EVENTS_SUCCESS:
      return {
        ...state,
        tasks: action.payload,
        openModal: false,
      };

    case STAFF_GET_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case STAFF_PART_DETAILS_SUCCESS:
      return {
        ...state,
        partDetails: action.payload,
      };

    case STAFF_PART_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SERVICE_PROGRESS_NOTE:
      return {
        ...state,
        progNotes_err: false,
      };

    case SERVICE_PROGRESS_NOTE_SUCCESS:
      return {
        ...state,
        progNotes: action.payload,
        progNotes_err: false,
        openModal: false,
      };

    case SERVICE_PROGRESS_NOTE_FAIL:
      return {
        ...state,
        progNotes_err: true,
        openModal: false,
      };

    case SERVICE_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        taskDetails: action.payload,
      };

    case SERVICE_ITEM_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case POST_CLOCK_IN_TIME_SUCCESS:
      return {
        ...state,
        clockInres: action.payload,
      };

    case POST_CLOCK_IN_TIME_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case SUBMIT_EMPLOYEE_COMPLAINT_FORM_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SUBMIT_EMPLOYEE_COMPLAINT_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return {
        ...state,
        loading: false,
      };
  }
};

export default StaffView;
